var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.387,
    height: 11.387,
    viewBox: "0 0 11.387 11.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "refresh_FILL0_wght400_GRAD0_opsz48",
    d: "M13.693,19.387A5.68,5.68,0,0,1,8,13.693,5.68,5.68,0,0,1,13.693,8a5.5,5.5,0,0,1,2.651.614A6.278,6.278,0,0,1,18.319,10.3V8h1.068v4.519H14.868V11.452h2.989a5.45,5.45,0,0,0-1.726-1.726,4.491,4.491,0,0,0-2.437-.658,4.587,4.587,0,0,0-4.626,4.626,4.587,4.587,0,0,0,4.626,4.626,4.666,4.666,0,0,0,2.7-.845,4.4,4.4,0,0,0,1.708-2.233h1.1a5.452,5.452,0,0,1-2.046,3.007A5.663,5.663,0,0,1,13.693,19.387Z",
    transform: "translate(-8 -8)",
    fill: "#98a1a9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.c512e9b0b21ad1a89ff5c536f2dcead2.svg";
export { ForwardRef as ReactComponent };